import script from "./CounterCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./CounterCard.vue?vue&type=script&setup=true&lang=ts"

import "./CounterCard.vue?vue&type=style&index=0&id=488f7142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-488f7142"]])

export default __exports__